<template>
    <div :style="{'max-width': '1300px', 'width': '90%', 'margin-left': 'auto', 'margin-right': 'auto', 'margin-top': '10px', 'padding-bottom': '100px'}">
        <b-card style="padding: 5px;" class="hidden-print">
            <h5>Refunds</h5>
            <div>
                <b-form @submit="search_sales">
                    
                    <div style="display: inline-block; vertical-align: top;">
                        <div>
                            <b-form-input style="width: 200px; display: inline-block;" v-model="query" type="text" required></b-form-input>
                        </div>
                        <sub>Enter invoice # / email / customer phone</sub>
                    </div>
                    <div style="display: inline-block; vertical-align: top;">
                        <b-button size="md" type="submit" variant="primary">Search</b-button>
                    </div>
                </b-form>
            </div>
        </b-card>

        <b-overlay :show="items_being_loaded" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">
            <b-card v-if="invoices.length > 0">
                <table class="text-monospace" style="width: 100%;">
                        <thead>
                            <tr style="background: #c3cdd3;">
                                <td class="ipt_tdhr" style="width: 120px;">
                                    DATE TIME
                                </td>
                                <td class="ipt_tdhr">
                                    INVOICE ID
                                </td>
                                <td class="ipt_tdhr">
                                    CUSTOMER
                                </td>
                                <td class="ipt_tdhr">
                                    ITEMS 
                                </td>
                                
                                <td class="ipt_tdhr">
                                    ACTION
                                </td>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="item,idx in invoices" v-bind:key="idx">
                                <td class="ipt_tdhr">
                                    {{ item.datetime }}
                                </td>
                                <td class="ipt_tdhr" @click="navigateToInvoice(item.invoice_id)">
                                    {{ item.invoice_id }}
                                </td>
                                <td class="ipt_tdhr">
                                    {{ item.customer_fullname }}
                                </td>
                                <td class="ipt_tdhr">
                                    <b-list-group>
                                        <b-list-group-item v-for="pitem,pidx in item.items" v-bind:key="pidx" style="font-size: 11px; padding: 2px; border: 1px;">{{pitem.product_name}} x ({{pitem.quantity}})</b-list-group-item>
                                    </b-list-group>
                                </td>
                                
                                <td class="ipt_tdhr non-header">
                                    <b-button size="sm" variant="warning" @click="fetchInvoiceForRefund(item)">VIEW</b-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>      
                
            </b-card>

            <div v-else>
                <b-card v-if="invoice.items.length > 0" class="text-monospace">
                    <h4>{{invoice.invoice_id}}</h4>
                    <div>
                        <b-card header="ITEMS LIST">
                            <table style="width: 100%;">
                                <thead>
                                    <tr style="background: white; border: 1px solid black;">

                                        <td class="ipt_tdhr" style="font-size: 13px;">
                                            PRODUCT
                                        </td>
                                        <td class="ipt_tdhr" style="font-size: 13px;">
                                            SOLD QTY
                                        </td>
                                        <td class="ipt_tdhr" style="font-size: 13px;">
                                            DLVRD QTY
                                        </td>
                                        <td class="ipt_tdhr" style="font-size: 13px;">
                                            TOTAL AMT
                                        </td>

                                        <td class="ipt_tdhr" style="font-size: 13px;">
                                            TOTAL TAX
                                        </td>

                                        <td class="ipt_tdhr" style="font-size: 13px;">
                                            TOTAL PAID
                                        </td>

                                        <td class="ipt_tdhr" style="font-size: 13px;">
                                            ALREADY REFUNDED 
                                        </td>

                                    </tr>
                                </thead>

                                <tbody>
                                    <tr v-for="item,idx in invoice.items" v-bind:data="item" v-bind:key="idx" style="border: 1px solid black;">
                                        <td class="ipt_tdhr">
                                            <div style="display: inline-block;">
                                                {{ item.product_name }}
                                            </div>

                                            <div>
                                                ({{ item.product_sku }})
                                                <span v-if="item.product_id < 0 || !item.product_id"> 
                                                <span><b-badge variant="warning" style="padding: 2px; font-size: 10px;">SPECIAL</b-badge></span>
                                            </span>
                                            </div>
                                        </td>
                                
                                        <td class="ipt_tdhr" style="font-weight: normal;">
                                            {{ item.quantity }}
                                        </td>

                                        <td class="ipt_tdhr" style="font-weight: normal;">
                                            {{ (item.delivered_quantity || item.quantity) }}
                                        </td>
                                
                                        <td class="ipt_tdhr" style="font-weight: normal;">
                                            ${{ parseFloat(item.total).toFixed(2) }}
                                        </td>

                                        <td class="ipt_tdhr" style="font-weight: normal;">
                                            ${{ (parseFloat(item.total) * 0.10 ).toFixed(2) }}
                                        </td>

                                        <td class="ipt_tdhr" style="font-weight: normal; ">
                                            ${{ ( (parseFloat(item.total) * 0.10) + parseFloat(item.total) ).toFixed(2)   }}
                                        </td>

                                        <td class="ipt_tdhr" style="font-weight: normal; width: 100px;">
                                            <div style="width: 40px; margin: auto; padding: 5px; font-weight: bold; background: #f2f2f2; border: 1px solid black;">
                                            {{ ( parseInt(item.refund_elements.length) || 0)  }}
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </b-card>

                        <b-card header="REFUNDED ITEMS">
                            <b-overlay :show="refund_being_generated" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">
                                <b-card-text>
                                    <b-button variant="dark" size="sm" @click="addRefundElement">ADD</b-button>
                                </b-card-text>

                                <b-card-text>
                                    <b-card-group deck>

                                        <b-card style="max-width: 20rem; min-width: 20rem;" v-for="ritem, ridx in refund_elements" v-bind:key="ridx" >
                                            <div style="font-size: 11px;">
                                                <div style="margin: 3px; display: inline-block; vertical-align: top;">
                                                    <div>PRODUCT</div>
                                                    <b-form-select :options="invoice.items.map(function(d){return {value: d.product_sku, text: d.product_name} })" size="sm" style="font-size: 10px; width: 200px;" v-model="ritem.product_sku" v-on:change="assignId(ritem)" :disabled="ritem.ts != null"></b-form-select>
                                                </div>

                                                <div v-if="ritem.product_sku">
                                                    <div style="margin: 3px; display: inline-block; vertical-align: top;">
                                                        <div>QTY</div>
                                                        <b-input size="sm" style="width: 40px; display: inline-block; text-align: center; font-size: 10px; margin: 0px; padding: 0px;" v-model="ritem.refund_quantity" :disabled="ritem.ts != null"></b-input>
                                                    </div>

                                                    <div style="margin: 3px; display: inline-block; vertical-align: top;">
                                                        <div>STATE</div>
                                                        <b-form-select size="sm" :options="conditions" v-model="ritem.refund_physical_condition" style="width: 140px; font-size: 10px;" :disabled="ritem.ts != null"></b-form-select>
                                                    </div>

                                                    <!-- <div style="margin: 3px; display: inline-block; vertical-align: top;">
                                                        <div>PAYMT MODE</div>
                                                        <b-form-select size="sm" :options="refund_payment_modes" v-model="ritem.refund_payment_mode" style="width: 120px; font-size: 10px;" :disabled="ritem.ts != null"></b-form-select>
                                                    </div> -->

                                                    <div style="margin: 3px; display: inline-block; vertical-align: top;">
                                                        <div style="">AMOUNT</div>
                                                        <b-button size="sm" variant="outline-dark" style="width: 100px; font-size: 10px;" :disabled="ritem.ts != null"> 
                                                            {{ get_refund_amount(ritem).toFixed(2) }}
                                                        </b-button>
                                                    </div>

                                                    <div style="margin: 3px; display: inline-block; vertical-align: top;" v-if="ritem.refund_physical_condition != 4">
                                                        <div>RETURN LOC</div>
                                                        <b-form-select size="sm" :options="packet.locsubs.filter(function(d){return d.location_id == invoice.location_id})" v-model="ritem.refund_locsub" style="width: 200px; font-size: 10px;" :disabled="ritem.ts != null"></b-form-select>
                                                    </div>

                                                    <div style="margin: 3px; display: inline-block; vertical-align: top;">
                                                        <div>CLAIM DETAIL</div>
                                                        <div>
                                                            <b-textarea size="sm" style="font-size: 11px; width: 200px;" v-model="ritem.note" placeholder="add any details here." rows="10" :disabled="ritem.ts != null"></b-textarea>
                                                        </div>
                                                    </div>


                                                    <b-card-text v-if="ritem.ts != null" style="font-size: 10px;">
                                                        CREATED BY {{ ritem.refunding_user }} at {{ ritem.ts }}
                                                    </b-card-text>

                                                    <b-card-text v-if="ritem.ts != null" style="font-size: 10px; color: green;">
                                                        <div>
                                                        RECEIVED STATUS: NO
                                                        </div>
                                                        <div>
                                                        RECEIVED QUANTITY: 0 
                                                        </div>
                                                    </b-card-text>

                                                    <div v-if="validate_qty(ritem)">
                                                        <div v-if="ritem.ts">
                                                            <b-button size="sm" variant="primary" @click="removeRefund(ritem, ridx)">DELETE</b-button>
                                                        </div>
                                                        <div v-else>
                                                            <b-button size="sm" variant="primary" @click="saveRefund(ritem)">SAVE</b-button>
                                                        </div>
                                                    </div>

                                                    <div v-else>
                                                        <b-alert variant="warning" show style="font-size: 10px;">
                                                            Total refund quantities for this item cannot exceed the originally purchased quantities.
                                                        </b-alert>
                                                        <b-button size="sm" variant="primary" @click="removeRefund(ritem, ridx)">DELETE</b-button>
                                                    </div>
                                                </div>
                                            </div>
                                        </b-card>
                                    </b-card-group>
                                </b-card-text>
                            </b-overlay>
                        </b-card>

                        <b-card header="REFUND CHARGES">
                            <b-alert variant="secondary" show style="width: auto; display: inline-block; font-size: 10px; vertical-align: top;">
                                <div style="margin: 3px; display: inline-block; vertical-align: top;">
                                    <div>DELIVERY (W/TAX)</div>
                                    <b-button size="sm" variant="error" :disabled="true" style="font-size: 10px;">{{  ( ((parseFloat(invoice.delivery_charges) || 0) * 0.10)  + (parseFloat(invoice.delivery_charges) || 0) ).toFixed(2) }}</b-button>
                                </div>

                                <div style="margin: 3px; display: inline-block; vertical-align: top;">
                                    <div style="visibility: hidden;">DUMMY</div>
                                    <b-form-checkbox v-model="invoice.delivery_refunded">OK</b-form-checkbox>
                                </div>
                            </b-alert>

                            <b-alert variant="secondary" show style="width: auto; display: inline-block; vertical-align: top; font-size: 10px;">
                                <div style="margin: 3px; display: inline-block; vertical-align: top;">
                                    <div>WARRANTY (W/TAX)</div>
                                    <b-button size="sm" variant="error" :disabled="true" style="font-size: 10px;">{{  ( ((parseFloat(invoice.warranty_charges) || 0) * 0.10)  + (parseFloat(invoice.warranty_charges) || 0) ).toFixed(2) }}</b-button>
                                </div>

                                <div style="margin: 3px; display: inline-block; vertical-align: top;">
                                    <div style="visibility: hidden;">DUMMY</div>
                                    <b-form-checkbox v-model="invoice.warranty_refunded">OK</b-form-checkbox>
                                </div>
                            </b-alert>

                            <b-alert variant="secondary" show style="width: auto; display: inline-block; vertical-align: top; font-size: 10px;">
                                <div style="margin: 3px; display: inline-block; vertical-align: top;">
                                    <div>SETUP (W/TAX)</div>
                                    <b-button size="sm" variant="error" :disabled="true" style="font-size: 10px;">{{  ( ((parseFloat(invoice.setup_charges) || 0) * 0.10)  + (parseFloat(invoice.setup_charges) || 0) ).toFixed(2) }}</b-button>
                                </div>

                                <div style="margin: 3px; display: inline-block; vertical-align: top;">
                                    <div style="visibility: hidden;">DUMMY</div>
                                    <b-form-checkbox v-model="invoice.setup_refunded">OK</b-form-checkbox>
                                </div>
                            </b-alert>
                        </b-card>

                        <b-card header="PAYMENT METHOD">
                            <div style="margin: 3px; display: inline-block; vertical-align: top;">
                                <div>HOW DO YOU WANT YOUR MONEY?</div>
                                <b-form-select size="sm" :options="refund_payment_modes" style="width: 120px; font-size: 10px;" ></b-form-select>
                            </div>
                        </b-card>



                    </div>
                </b-card>

                

            </div>
        </b-overlay>

    </div>
</template>

<script>
    import _ from 'underscore'
    import moment from 'moment'
    import global_vars from '@/utilities/global_vars'
    import Backer from '@/components/globals/Backer'
    import Requestor from '@/utilities/Requestor'

    export default {
        name: "Refunds",
        components: {Backer},
        data: function(){
            return {
                packet: {},
                query: null,
                invoices: [],
                invoice: {items: []},
                invoice_id: null,
                items_being_loaded: false,
                message: "No invoice loaded",
                items: [],
                refund_being_generated: false,
                existing_refunds: [],
                conditions: [
                    {value: 1, text: "New"},
                    {value: 2, text: "Open Box"},
                    {value: 3, text: "Damaged"},
                    {value: 4, text: "Never Delivered"}
                ],
                refund_payment_modes: [
                    {value: 1, text: "Credit Card"},
                    {value: 2, text: "Cash"},
                    {value: 3, text: "Store Credit"}
                ],
                refund_elements: []
            }
        },
        methods: {
            navigateToInvoice: function(invoice_id){
                let route = this.$router.resolve({path: "/sales/viewsale/"+invoice_id+"/"});
                window.open(route.href, '_blank');
            },
            get_refund_amount: function(ritem){
                let item = this.invoice.items.filter(function(d){
                    return d.product_sku == ritem.product_sku
                })
                let refund_amount = 0.0;
                if (item.length> 0){
                    item = item[0];
                    refund_amount = (((parseFloat(item.total) * 0.10) + parseFloat(item.total) ) / (parseInt(item.quantity))) * (parseInt(ritem.refund_quantity) || 0)
                }
                return refund_amount
            },
            assignId: function(ritem){
                let product_sku = ritem.product_sku;

                let filtered = this.invoice.items.filter(function(d){
                    return d.product_sku == product_sku
                });

                if (filtered.length > 0){
                    filtered = filtered[0];
                    ritem.product_id = filtered.product_id;
                }
            },
            saveRefund: function(ritem){
                
                let path = "/api/sales/save_refund/"
                let data = ritem;
                data.refunding_user = this.packet.userDetails.username;
                data.refund_amount = this.get_refund_amount(ritem);
                let that = this;
                
                let s = function(response) {
                    if (response.data.error) {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "Created a refund.", 
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );

                        ritem.ts = response.data.result[0].ts;
                    }
                    that.refund_being_generated = false;
                }
                let f = function(error) {
                    that.$bvToast.toast(
                        "Error generatung refund(s). Please try again later.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.refund_being_generated = false;
                }
                this.refund_being_generated = true;
                Requestor.postSyncP(path, data, this, s, f);

            },
            removeRefund: function(ritem, ridx){
                let path = "/api/sales/delete_refund/"
                let data = ritem;
                let that = this;

                if (!ritem.id){
                    this.refund_elements.splice(ridx, 1);
                    return
                }

                let s = function(response) {
                    if (response.data.error) {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "Deleted a refund.", 
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );

                        that.refund_elements.splice(ridx, 1);
                    }
                    that.refund_being_generated = false;
                }
                let f = function(error) {
                    that.$bvToast.toast(
                        "Error generatung refund(s). Please try again later.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.refund_being_generated = false;
                }
                this.refund_being_generated = true;
                Requestor.postSyncP(path, data, this, s, f);
            },
            search_sales: function(e){
                if (e){
                    e.preventDefault();
                }

                if (!this.query){
                    this.$vex.dialog.alert({message: "Please enter a valid search term."})
                    return
                }

                let path = "/api/sales/get_sales/"
                //this.search_term = this.search_term.replace(/\s+$/,"").replace(/^\s+/,"");
                let data = {query: {invoice_id: this.query}, userid: this.packet.userDetails.id}
                let that = this;
                let s = function(response){
                    if (response.data.result){
                        that.invoices = response.data.result
                        
                        if (that.invoices.length <= 0){
                            that.message = "No invoices found."
                        }
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false;
                }
                let f = function(error){
                    console.log(error)
                    that.$bvToast.toast(
                        "Error loading invoice. Please try again later.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false;
                }
                this.items_being_loaded=true;
                Requestor.postSyncP(path, data, this, s, f);
            },

            addNewRefundItem: function(item){
                console.log(item)
                if (!item.refund_elements) {
                    item.refund_elements = [];
                }

                let refund_element = {};
                refund_element.ts = null;
                refund_element.invoice_id = this.invoice.invoice_id;
                refund_element.product_id = item.product_id;
                refund_element.product_sku = item.product_sku;
                refund_element.refund_locsub = null;
                refund_element.refund_physical_condition = null;
                refund_element.refund_payment_mode = null;
                refund_element.refund_quantity = null;

                item.refund_elements.push(
                    refund_element
                )
                return
            },

            fetchInvoiceForRefund: function(invoice){
                this.invoices = [];
                this.invoice = invoice;
                let refund_elements = this.invoice.items.map(function(d){
                    return d.refund_elements
                });
                this.refund_elements = _.flatten(refund_elements);
                return

                if (!this.invoice_id){
                    this.$vex.dialog.alert({message: "Please enter a valid invoice id."})
                    return
                }

                let path = "/api/sales/get_invoice_items/"
                this.invoice_id = this.invoice_id.replace(/\s+$/,"").replace(/^\s+/,"");
                let data = {invoice_id: this.invoice_id}
                let that = this;
                let s = function(response){
                    if (response.data.result){
                        that.items = response.data.result
                        
                        if (that.items.length <= 0){
                            that.message = "No invoice found."
                        }
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false;
                }
                let f = function(error){
                    console.log(error)
                    that.$bvToast.toast(
                        "Error loading invoice. Please try again later.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false;
                }
                this.items_being_loaded=true;
                Requestor.getSyncP(path, data, this, s, f);
            },
            anyItemRefundable: function(){
                let items = this.items.filter(function(d){
                    return (
                        isNaN(parseInt(d.refund_amount)) == false 
                    ) && (
                        !(d.refund_ts)
                    )
                });

                if (items.length > 0){
                    return false
                }
                else {
                    return true
                }
            },
            removeRefundElement: function(idx, ridx){
                this.invoice.items[idx].refund_elements.splice(ridx, 1);
            },
            addRefundElement: function(e){
                if (e){
                    e.preventDefault();
                }

                let refund_element = {
                    product_id: null,
                    product_sku: null,
                    invoice_id: this.invoice.invoice_id,
                    refund_amount: null,
                    refund_quantity: null,
                    refund_locsub: null,
                    refund_physical_condition: null,
                    refund_payment_mode: null,
                    notes: null,
                }

                this.refund_elements.push(refund_element);

            },
            validate_qty: function(ritem){
                let product_sku = ritem.product_sku;

                let purchased_quantity = this.invoice.items.filter(function(d){
                    return d.product_sku == product_sku
                }).map(function(d){ return d.quantity });

                let total_refund_quantity = this.refund_elements.filter(function(d){return d.product_sku == product_sku}).map(function(d){
                    return (parseInt(d.refund_quantity) || 0)
                })
                
                purchased_quantity = _.reduce(purchased_quantity, function(a, b) { return a + b}, 0)
                total_refund_quantity = _.reduce(total_refund_quantity, function(a, b) { return a + b}, 0)

                if (total_refund_quantity  > purchased_quantity){
                    return false
                }
                else {
                    return true
                }
            }
        },
        created: function(){
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            //this.fetch_prereqs()
        }
    }
</script>

<style scoped>
    td {
        border: 1px solid gray;
        font-size: 12px;
    }

    .input-txt {
        border: 0px; 
        font-weight: normal; 
        color: #2c3e50; 
        display: inline; 
        padding: 0px; 
        margin: 0px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Sales/Refunds.vue